/* PARFUMPROBEN VERSAND – Warenkorb-Vorteile mit Gratisprobe (gehört zu snippets/ppv-cart-rewards.liquid). */
(() => {
  const ELEMENT_NAME = 'ppv-cart-rewards';
  const STORE_KEY = 'ppv.gratisprobe';
  const ATTRIBUTE = 'Gratisprobe';
  const ATTRIBUTE_VARIANT = 'Gratisprobe-Variante';
  const root = () => window.Shopify?.routes?.root || '/';

  document.querySelectorAll('style[data-ppv-cart-rewards-style]').forEach((style, index) => {
    if (index === 0) {
      if (style.parentElement !== document.head) document.head.appendChild(style);
    } else {
      style.remove();
    }
  });

  /* Gemeinsamer Zustand für Einschub und Warenkorbseite: letzter Warenkorb, Wahl, Abgleich des Vermerks. */
  const state = window.__PPV_FREE_SAMPLE__ || (window.__PPV_FREE_SAMPLE__ = { cart: null, queue: Promise.resolve(), pending: 0 });

  /* Die Wahl gilt nur für diesen Warenkorb – nach einer Bestellung (neuer Warenkorb) ist sie vergessen. */
  const readChoice = () => {
    let value = null;
    try {
      value = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
    } catch (error) {
      value = state.memoryChoice || null;
    }
    if (!value || !value.variant) return null;
    const token = state.cart && state.cart.token;
    return value.cart && token && value.cart !== token ? null : value;
  };

  const writeChoice = choice => {
    const value = choice ? { ...choice, cart: (state.cart && state.cart.token) || null } : null;
    state.memoryChoice = value;
    try {
      if (value) localStorage.setItem(STORE_KEY, JSON.stringify(value));
      else localStorage.removeItem(STORE_KEY);
    } catch (error) {
      /* Ohne Speicher gilt die Wahl bis zum Neuladen. */
    }
  };

  const offered = () => {
    const cards = document.querySelectorAll(`${ELEMENT_NAME} .ppv-free-sample__card`);
    return new Map([...cards].map(card => [card.dataset.variant, card.dataset.title]));
  };

  const thresholdOf = () => Number(document.querySelector(ELEMENT_NAME)?.dataset.sampleThreshold) || 3000;

  /* Wahl dieses Warenkorbs: vorgemerkt, sonst der Vermerk, den der Warenkorb schon trägt (anderer Tab, Gerät …).
     Ohne eigene Wahl ist ab dem Mindestbestellwert automatisch die erste angebotene Probe gewählt – so nennt jede
     Bestellung ab 30 € eine Probe; der Kunde kann jederzeit eine andere antippen. */
  const currentChoice = cart => {
    const options = offered();
    const stored = readChoice();
    if (stored && options.has(String(stored.variant))) return { variant: String(stored.variant), title: options.get(String(stored.variant)) };
    const attributes = (cart && cart.attributes) || {};
    const variant = String(attributes[ATTRIBUTE_VARIANT] || '');
    if (!stored && variant && options.has(variant)) {
      const adopted = { variant, title: options.get(variant) };
      writeChoice(adopted);
      return adopted;
    }
    if (cart && cart.item_count > 0 && cart.total_price >= thresholdOf() && options.size) {
      const [firstVariant, firstTitle] = options.entries().next().value;
      const preset = { variant: firstVariant, title: firstTitle };
      writeChoice(preset);
      return preset;
    }
    return null;
  };

  /* Vermerk am Warenkorb nur ab dem Mindestbestellwert – darunter bleibt die Wahl nur vorgemerkt. */
  const syncAttributes = cart => {
    if (!cart) return state.queue;
    const choice = currentChoice(cart);
    const wanted = choice && cart.item_count > 0 && cart.total_price >= thresholdOf() ? choice : null;
    const attributes = cart.attributes || {};
    const title = wanted ? wanted.title : '';
    const variant = wanted ? wanted.variant : '';
    if ((attributes[ATTRIBUTE] || '') === title && String(attributes[ATTRIBUTE_VARIANT] || '') === variant) return state.queue;
    state.pending += 1;
    state.queue = state.queue
      .then(() =>
        fetch(`${root()}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [ATTRIBUTE]: title, [ATTRIBUTE_VARIANT]: variant } })
        })
      )
      .then(response => (response.ok ? response.json() : null))
      .then(updated => {
        if (updated) state.cart = updated;
      })
      .catch(() => {})
      .finally(() => {
        state.pending -= 1;
      });
    return state.queue;
  };

  const renderAll = () => document.querySelectorAll(ELEMENT_NAME).forEach(element => element.render?.());

  if (!customElements.get(ELEMENT_NAME)) {
    class PPVCartRewards extends HTMLElement {
      connectedCallback() {
        this.sampleThreshold = Number(this.dataset.sampleThreshold) || 3000;
        this.shippingThreshold = Number(this.dataset.shippingThreshold) || 5000;
        this.currency = this.dataset.currency || 'EUR';
        if (!this.bound) {
          this.bound = true;
          this.addEventListener('click', event => {
            const card = event.target.closest('.ppv-free-sample__card');
            if (!card || !this.contains(card)) return;
            /* Wie Optionsfelder: Antippen wählt, erneutes Antippen behält die Wahl (ab 30 € ist immer eine gewählt). */
            writeChoice({ variant: card.dataset.variant, title: card.dataset.title });
            renderAll();
            syncAttributes(state.cart);
          });
        }
        this.render();
        this.refresh();
      }

      money(cents) {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.currency, minimumFractionDigits: 2 }).format(Math.max(0, cents) / 100);
      }

      render() {
        const cart = state.cart;
        const total = cart ? cart.total_price || 0 : Number(this.dataset.total) || 0;
        const count = cart ? cart.item_count || 0 : total > 0 ? 1 : 0;
        const sampleReached = total >= this.sampleThreshold;
        const shippingReached = total >= this.shippingThreshold;
        const message = this.querySelector('.ppv-cart-rewards__message');
        const progressBar = this.querySelector('.ppv-cart-rewards__progress');
        const fill = this.querySelector('.ppv-cart-rewards__fill');
        if (!message || !progressBar || !fill) return;

        fill.style.width = `${(Math.max(0, Math.min(total, this.shippingThreshold)) / this.shippingThreshold) * 100}%`;
        progressBar.setAttribute('aria-valuenow', String(Math.min(50, Math.round(total / 100))));
        this.querySelector('.ppv-cart-rewards__point--sample')?.classList.toggle('is-reached', sampleReached);
        this.querySelector('.ppv-cart-rewards__point--shipping')?.classList.toggle('is-reached', shippingReached);
        this.querySelector('.ppv-cart-rewards__label--sample')?.classList.toggle('is-reached', sampleReached);
        this.querySelector('.ppv-cart-rewards__label--shipping')?.classList.toggle('is-reached', shippingReached);

        if (!sampleReached) {
          message.innerHTML = `Noch <strong>${this.money(this.sampleThreshold - total)}</strong> bis zu deiner Gratisprobe`;
        } else if (!shippingReached) {
          message.innerHTML = `Gratisprobe freigeschaltet – noch <strong>${this.money(this.shippingThreshold - total)}</strong> bis zum Gratisversand`;
        } else {
          message.innerHTML = `<strong>Gratisprobe und Gratisversand</strong> freigeschaltet`;
        }

        const picker = this.querySelector('.ppv-free-sample');
        if (!picker) return;
        picker.hidden = count === 0;
        const choice = currentChoice(cart);
        picker.querySelectorAll('.ppv-free-sample__card').forEach(card => {
          card.setAttribute('aria-pressed', String(Boolean(choice) && card.dataset.variant === choice.variant));
        });
        const status = picker.querySelector('.ppv-free-sample__status');
        if (status) {
          status.textContent = choice
            ? sampleReached
              ? 'Wird deiner Bestellung gratis beigelegt.'
              : `Vorgemerkt – ab ${this.money(this.sampleThreshold)} legen wir sie dir bei.`
            : sampleReached
              ? 'Ohne Auswahl legen wir dir eine Überraschung bei.'
              : '';
        }
      }

      async refresh() {
        try {
          const response = await fetch(`${root()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          this.currency = cart.currency || this.currency;
          this.dataset.total = String(cart.total_price || 0);
          state.cart = cart;
          renderAll();
          syncAttributes(cart);
        } catch (error) {
          /* Der Liquid-Wert bleibt als Rückfallebene sichtbar. */
        }
      }
    }

    customElements.define(ELEMENT_NAME, PPVCartRewards);
  }

  const firstElement = document.querySelector(ELEMENT_NAME);
  if (firstElement && !window.PPV_CART_REWARDS_TEMPLATE) {
    window.PPV_CART_REWARDS_TEMPLATE = firstElement.outerHTML;
  }

  if (window.__PPV_CART_REWARDS_CONTROLLER__) return;
  window.__PPV_CART_REWARDS_CONTROLLER__ = true;

  /* Checkout erst, wenn der Vermerk am Warenkorb steht: Warenkorb frisch lesen, Vermerk abgleichen (auch die
     Vorauswahl ab 30 €), dann weiter – höchstens 2,5 s warten, damit der Checkout nie hängen bleibt. */
  document.addEventListener(
    'submit',
    event => {
      const submitter = event.submitter;
      const form = event.target;
      if (!submitter || submitter.name !== 'checkout' || form.dataset.ppvSampleChecked === '1') return;
      event.preventDefault();
      let done = false;
      const proceed = () => {
        if (done) return;
        done = true;
        form.dataset.ppvSampleChecked = '1';
        if (form.requestSubmit) {
          form.requestSubmit(submitter);
        } else {
          const checkout = document.createElement('input');
          checkout.type = 'hidden';
          checkout.name = 'checkout';
          checkout.value = submitter.value || '';
          form.appendChild(checkout);
          form.submit();
        }
        delete form.dataset.ppvSampleChecked;
      };
      setTimeout(proceed, 2500);
      fetch(`${root()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(response => (response.ok ? response.json() : null))
        .then(cart => {
          if (!cart) return state.queue;
          state.cart = cart;
          renderAll();
          return syncAttributes(cart);
        })
        .catch(() => {})
        .finally(proceed);
    },
    true
  );

  /* Die Theme-Skripte ersetzen den Einschub bei jeder Änderung. Das lebende Element wird sofort (vor dem Zeichnen)
     wieder eingesetzt – mit Auswahl und Fortschritt, ohne Springen. */
  const places = { drawer: null, page: null };

  const fromTemplate = () => {
    if (!window.PPV_CART_REWARDS_TEMPLATE) return null;
    const holder = document.createElement('div');
    holder.innerHTML = window.PPV_CART_REWARDS_TEMPLATE;
    return holder.firstElementChild;
  };

  /* parent: als erstes Kind dort einsetzen (Einschub: Anfang der scrollenden Artikelliste). Ist dort gerade ein
     Mengenknopf o. Ä. fokussiert, bleibt er an seiner Stelle – der Block kommt oberhalb dazu, ohne dass die Liste springt. */
  const prependKeepingFocus = (parent, element) => {
    if (parent.firstElementChild === element) return;
    const focused = document.activeElement;
    const keep = focused && focused !== document.body && parent.contains(focused) && !element.contains(focused);
    const before = keep ? focused.getBoundingClientRect().top : 0;
    parent.prepend(element);
    if (keep) parent.scrollTop += focused.getBoundingClientRect().top - before;
  };

  const place = (key, container, anchor, parent) => {
    if (!container) return;
    const present = [...container.querySelectorAll(ELEMENT_NAME)];
    let element = places[key];
    if (element && !container.contains(element) && present[0]) {
      /* Frisch gerenderte Kopie markiert die richtige Stelle – dort das lebende Element einsetzen. */
      present[0].replaceWith(element);
    } else if (!element) {
      element = present[0] || fromTemplate();
    }
    if (!element) return;
    places[key] = element;
    container.querySelectorAll(ELEMENT_NAME).forEach(other => {
      if (other !== element) other.remove();
    });
    if (parent) {
      prependKeepingFocus(parent, element);
    } else if (anchor) {
      if (anchor.nextElementSibling !== element) anchor.insertAdjacentElement('afterend', element);
    } else if (!container.contains(element)) {
      container.prepend(element);
    }
  };

  const placeAll = () => {
    const drawer = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
    if (drawer) {
      const inner = drawer.querySelector('.drawer__inner') || drawer;
      /* In der scrollenden Artikelliste statt fest unter der Kopfzeile – auf dem Handy scrollt der Block mit weg. */
      const scroller = inner.querySelector('cart-drawer-items');
      if (scroller) place('drawer', inner, null, scroller);
      else place('drawer', inner, inner.querySelector('.drawer__header'));
    }
    const isCartPage = /(^|\/)cart\/?$/.test(window.location.pathname) || document.body.classList.contains('template-cart');
    const cartSection = isCartPage ? document.querySelector('#main-cart-items') : null;
    if (cartSection) {
      /* Die Warenkorb-Seite rendert den Block selbst (unter „Weiter shoppen“) – nur Doppelte entfernen. */
      const wrapper = cartSection.closest('[id^="shopify-section-"]') || cartSection.parentElement;
      place('page', wrapper, wrapper.querySelector('.cart__warnings') || wrapper.querySelector('.title-wrapper-with-link'));
    } else {
      document.querySelectorAll(ELEMENT_NAME).forEach(element => {
        if (!element.closest('#CartDrawer,cart-drawer')) element.remove();
      });
    }
  };

  let refreshTimer;
  const refreshSoon = delay => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      const element = document.querySelector(ELEMENT_NAME);
      element?.refresh?.();
    }, delay ?? 120);
  };

  const WATCHED = '#CartDrawer, cart-drawer, #main-cart-items, cart-items';
  const isRelevantMutation = mutation => {
    const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (!target || target.closest(ELEMENT_NAME)) return false;
    if (target.closest(WATCHED)) return true;
    return [...mutation.addedNodes, ...mutation.removedNodes].some(
      node => node.nodeType === 1 && (node.matches?.(WATCHED) || node.querySelector?.(WATCHED))
    );
  };

  new MutationObserver(mutations => {
    if (!mutations.some(isRelevantMutation)) return;
    placeAll();
    refreshSoon(80);
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('change', event => {
    if (event.target.matches?.('input[name="updates[]"],input[name="quantity"],select[name="updates[]"],.quantity__input')) refreshSoon(450);
  });

  document.addEventListener('click', event => {
    if (event.target.closest?.('cart-remove-button,quantity-input,.quantity__button,[data-cart-remove],[href*="/cart/change"],button[name="add"],[name="add"]')) {
      refreshSoon(550);
      setTimeout(() => refreshSoon(50), 1100);
    }
  });

  ['cart:updated', 'cart-updated', 'ajaxCart:updated', 'shopify:cart:updated'].forEach(eventName => {
    document.addEventListener(eventName, () => refreshSoon(50));
  });

  window.addEventListener('pageshow', () => {
    placeAll();
    refreshSoon(20);
  });
  placeAll();
})();
